import { LocationsServiceInterface } from 'domain/services/locations';
import {
  GetAddressViaZipCodeUseCaseInterface,
  GetAllCitiesForSelectOptionsUseCaseInterface,
  GetAllCountriesUseCaseInterface,
  GetCoordinatesFromAddressUseCaseInterface,
} from 'domain/usecases';

interface UseCasesInjection {
  getAllCitiesForSelectOptions: GetAllCitiesForSelectOptionsUseCaseInterface;
  getAddressViaZipCode: GetAddressViaZipCodeUseCaseInterface;
  getCoordinatesFromAddress: GetCoordinatesFromAddressUseCaseInterface;
  getAllCountries: GetAllCountriesUseCaseInterface;
}

export class LocationsService implements LocationsServiceInterface {
  private readonly _getAllCitiesForSelectOptionsUseCase: GetAllCitiesForSelectOptionsUseCaseInterface;
  private readonly _getAddressViaZipCodeUseCase: GetAddressViaZipCodeUseCaseInterface;
  private readonly _getCoordinatesFromAddressUseCase: GetCoordinatesFromAddressUseCaseInterface;
  private readonly _getAllCountriesUseCase: GetAllCountriesUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllCitiesForSelectOptionsUseCase =
      usecases.getAllCitiesForSelectOptions;
    this._getAddressViaZipCodeUseCase = usecases.getAddressViaZipCode;
    this._getCoordinatesFromAddressUseCase = usecases.getCoordinatesFromAddress;
    this._getAllCountriesUseCase = usecases.getAllCountries;
  }

  async getAllCitiesForSelectOptions(
    params: GetAllCitiesForSelectOptionsUseCaseInterface.Params,
  ): Promise<GetAllCitiesForSelectOptionsUseCaseInterface.Result> {
    return await this._getAllCitiesForSelectOptionsUseCase.execute(params);
  }

  async getAddressViaZipCode(
    params: GetAddressViaZipCodeUseCaseInterface.Params,
  ): Promise<GetAddressViaZipCodeUseCaseInterface.Result> {
    return await this._getAddressViaZipCodeUseCase.execute(params);
  }

  async getCoordinatesFromAddress(
    params: GetCoordinatesFromAddressUseCaseInterface.Params,
  ): Promise<GetCoordinatesFromAddressUseCaseInterface.Result> {
    return await this._getCoordinatesFromAddressUseCase.execute(params);
  }

  async getAllCountries(): Promise<GetAllCountriesUseCaseInterface.Result> {
    return await this._getAllCountriesUseCase.execute();
  }
}
